import map from 'lodash/fp/map';
import pipe from 'lodash/fp/pipe';
import replace from 'lodash/fp/replace';
import split from 'lodash/fp/split';
import toNumber from 'lodash/fp/toNumber';

function parseAppVersion(user_agent: string): [number, number, number | undefined] | null {
  if (!user_agent.includes('Posty')) {
    return null;
  }

  const match = /Posty\/(\d+)\.(\d+)(?:\.(\d+))?/.exec(user_agent);
  if (!match) {
    return null;
  }

  return [Number(match[1]), Number(match[2]), match[3] ? Number(match[3]) : undefined];
}

// 메인 화면을 네이티브로 전환한 포스티 앱인지 여부를 반환한다.
export const isPostyNativeMain = () => {
  const user_agent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
  const app_version = parseAppVersion(user_agent);
  if (app_version && (app_version[0] >= 3 || (app_version[0] === 2 && app_version[1] >= 99))) {
    return true;
  }
  return false;
};

const toBeParts = pipe(split('.'), map(pipe(replace(/\D+/g, ''), toNumber)));

const compareVersion = (current_version: (number | undefined)[], target_version: (number | undefined)[]) => {
  const max_length = Math.max(current_version.length, target_version.length);

  for (let i = 0; i < max_length; i++) {
    const current = current_version[i] ?? 0;
    const target = target_version[i] ?? 0;

    if (current === target) {
      continue;
    } else if (current > target) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};

export const compareWithPostyAppVersion = (version: string, user_agent = navigator?.userAgent) => {
  const app_version = parseAppVersion(user_agent);
  if (!app_version) {
    return false;
  }

  return compareVersion(app_version, toBeParts(version));
};
